import { useState } from 'react';
import './CommandActions.css';

const CLICK_TYPES = [
  'actions',
  'left-click',
  'right-click',
  'shift-left-click',
  'shift-right-click',
];

function isSupportedActionType(panelType, itemType) {
  if (panelType === 'inventory') return CLICK_TYPES;
  if (panelType === 'floodgate') return ['actions'];
  if (panelType === 'dialog' && itemType === 'button') return ['actions'];

  if (panelType === 'settings') {
    const base = ['open'];
    if (itemType === 'dialog') {
      return [...base, 'refresh'];
    }
    if (itemType === 'inventory') {
      return [...base, 'close', 'refresh', 'outside'];
    }
    return base;
  }
  
  return [];
}

export default function CommandActions({
  panelType,
  itemType,
  actions = {},
  setActions,
}) {
  const validTypes = isSupportedActionType(panelType, itemType);
  const [showAddDropdown, setShowAddDropdown] = useState(false);
  const [addingActionType, setAddingActionType] = useState('');

  const addActionBlock = (type) => {
    if (!type || actions[type]) return;
    setActions({
      ...actions,
      [type]: {
        requirements: [],
        commands: [],
        fail: [],
      },
    });
    setShowAddDropdown(false);
    setAddingActionType('');
  };

  const removeActionBlock = (type) => {
    const updated = { ...actions };
    delete updated[type];
    setActions(updated);
  };

  const updateActionField = (type, field, valueList) => {
    setActions({
      ...actions,
      [type]: {
        ...actions[type],
        [field]: valueList,
      },
    });
  };

  const handleChangeList = (type, field, index, newValue) => {
    const list = [...(actions[type]?.[field] || [])];
    list[index] = newValue;
    updateActionField(type, field, list);
  };

  const handleAddEntry = (type, field) => {
    const list = [...(actions[type]?.[field] || [])];
    list.push('');
    updateActionField(type, field, list);
  };

  const handleRemoveEntry = (type, field, index) => {
    const list = [...(actions[type]?.[field] || [])];
    list.splice(index, 1);
    updateActionField(type, field, list);
  };

  if (validTypes.length === 0) {
    return (
      <div style={{ fontStyle: 'italic', color: 'gray' }}>
        This item type does not support command actions.
      </div>
    );
  }

  const availableToAdd = validTypes.filter((type) => !actions[type]);

  return (
    <div className="command-actions">
        {validTypes.map((type) => {
        const actionBlockExists = actions[type];

        return actionBlockExists ? (
            <div
            key={type}
            className="action-block"
            style={{
                border: '1px solid #444',
                padding: '10px',
                marginBottom: '1rem',
                borderRadius: '6px',
            }}
            >
            <div
                style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                }}
            >
                <strong>{type}</strong>
                <button
                    className="remove-button"
                    type="button"
                    onClick={() => removeActionBlock(type)}
                >
                −
                </button>
            </div>

            {['requirements', 'commands', 'fail'].map((field) => (
                <div key={field} className="action-field" style={{ marginTop: '10px' }}>
                <strong>{field.charAt(0).toUpperCase() + field.slice(1)}</strong>
                {(actions[type]?.[field] || []).map((entry, idx) => (
                    <div
                    key={idx}
                    style={{ display: 'flex', gap: '6px', marginBottom: '4px' }}
                    >
                    <input
                        type="text"
                        value={entry}
                        onChange={(e) =>
                        handleChangeList(type, field, idx, e.target.value)
                        }
                        style={{ flexGrow: 1 }}
                    />
                    <button
                        className="remove-button"
                        type="button"
                        onClick={() => handleRemoveEntry(type, field, idx)}
                    >
                        −
                    </button>
                    </div>
                ))}
                <button
                    className="add-button"
                    type="button"
                    onClick={() => handleAddEntry(type, field)}
                >
                    +
                </button>
                </div>
            ))}
            </div>
        ) : (
            validTypes.length === 1 && (
            <button
                key="add-default-action"
                className="add-button"
                type="button"
                onClick={() => addActionBlock(type)}
            >
                +
            </button>
            )
        );
        })}

      {validTypes.length > 1 && (
        <div className="add-action-block">
          {showAddDropdown ? (
            <>
              <select
                value={addingActionType}
                onChange={(e) => setAddingActionType(e.target.value)}
                aria-label="Select action type to add"
              >
                <option value="" disabled>
                  Select action type...
                </option>
                {availableToAdd.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
              <button
                onClick={() => addActionBlock(addingActionType)}
                disabled={!addingActionType}
                className="add-button add-confirm"
                type="button"
              >
                +
              </button>
              <button
                onClick={() => {
                  setShowAddDropdown(false);
                  setAddingActionType('');
                }}
                className="cancel-button"
                type="button"
              >
                ×
              </button>
            </>
          ) : (
            availableToAdd.length > 0 && (
              <button
                className="add-button"
                type="button"
                onClick={() => setShowAddDropdown(true)}
              >
                +
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
}